import { useNavigate } from 'react-router-dom'

//lib
import { MDBCol, MDBContainer, MDBRow } from 'mdb-react-ui-kit'
import { Swiper, SwiperSlide } from 'swiper/react'
import { EffectCreative } from 'swiper'
import IconVerifyDAgent from '../../../assets/images/icon/icon-verify-dagent.png'

//hook
import useWindowDimensions from '../../../components/common/window-dimension'

//redux
import { useDispatch, useSelector } from 'react-redux'
import { setSection } from '../../../redux/reducer/calculatorReducer'
import {
  setCar1Data,
  setCar2Data,
  setCar3Data,
  setChooseBrand,
} from '../../../redux/reducer/carCompareReducer'
import { setOpenJapanModal } from '../../../redux/reducer/homeReducer'

//helper
import LazyImage from '../../../components/common/common.image'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { HomeFashion, HomeFashionBg } from '../../../assets/images'

export default function FashionCollection() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { direct_import_listing, direct_import_action, isDarkMode } = useSelector(
    (state) => state.home,
  )
  const { width, height } = useWindowDimensions()

  return (
    <MDBContainer className="dc-fashion-container">
      {/* <MDBRow className="main-title-row">
        <label className="_title-special-text">
          D -{' '}
          <span
            className="_titlesec"
            style={{
              color:
                (height > 600 && width >= 653 && width < 992 && !isDarkMode) ||
                (height > 850 && width >= 991 && !isDarkMode)
                  ? '#D1D5DB'
                  : '',
            }}>
            FASHION
          </span>
        </label>
      </MDBRow> */}
      <div
        className="box-container fashion-box mt-3 pointer"
        onClick={() => window.open('https://dcfashion.shop', '_blank')}>
        <MDBRow>
          <MDBCol className={`col-${width < 768 ? 12 : width < 991 ? 7 : 8}`}>
            <h1>The DC V12 Collection</h1>
            <p>
              The DC V12 Collection merges high-performance style with luxury, featuring sleek
              designs, premium fabrics, and motorsport-inspired details for a bold, speed-driven
              look.
            </p>
            <button>Shop Now</button>
          </MDBCol>
          <MDBCol className={`col-${width < 768 ? 12 : width < 991 ? 5 : 4}`}>
            <div className="fashion-frame">
              <LazyLoadImage src={HomeFashion} alt="dc-fashion" />
            </div>
          </MDBCol>
        </MDBRow>
      </div>
    </MDBContainer>
  )
}
